import { FC } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { QueryProviderProps } from './server.types'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      useErrorBoundary: true,
      cacheTime: Infinity,
    },
    mutations: {
      useErrorBoundary: true,
    }
  },
})

export const QueryProvider: FC<QueryProviderProps> = ({ children }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
)
